import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import usePermission from 'routes/usePermission';
import { GET_ACTION } from './helper';

const useDowntimeRefundHome = () => {
	const { hasPermission } = usePermission();
	const isEnabled = (subEntity: string) => {
		return hasPermission({
			configPageName: PAGE_NAMES.dashboard,
			entity: DASHBOARD_RESOURCES.downtimeRefund,
			action: GET_ACTION[subEntity]
		});
	};
	return { isEnabled };
};

export default useDowntimeRefundHome;
